import { render, staticRenderFns } from "./ProductApartment.vue?vue&type=template&id=922652e6&scoped=true"
import script from "./ProductApartment.vue?vue&type=script&lang=js"
export * from "./ProductApartment.vue?vue&type=script&lang=js"
import style0 from "./ProductApartment.vue?vue&type=style&index=0&id=922652e6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_2aqslel7prtkk4onzp5d3vudie/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "922652e6",
  null
  
)

export default component.exports